import { t } from 'ttag';
import {
  FlipBackDefinition,
  FlipCardDefinition,
  FLIP_BACK,
  FLIP_CARD,
  FLIP_FRONT,
  IMAGE,
  ImageDefinition,
  LayoutListDefinition,
  LAYOUT_LIST,
  TEXT,
  TextDefinition,
  PERSONALIZED_CARD
} from '../items';
import { Translator } from '../Translator';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';
import { isMobile } from 'react-device-detect';

const itemWidth: { [key: number]: { width: string; height: string } } = {
  1: { width: '100%', height: '54vh' }, // height -10%
  2: { width: '40.5%', height: '54vh' },
  3: { width: '27%', height: '54vh' },
  4: { width: '40.5%', height: '27vh' },
  5: { width: '27%', height: '27vh' },
  6: { width: '27%', height: '27vh' }
};

export const Cards3: Translator = sequence => {
  let isContentEditable = false;
  try {
    const { contentEditable } = useEditorStore.getState();
    isContentEditable = !!contentEditable;
  } catch (e) {
    // ignore if store not available
  }

  const cardCount =
    sequence.items?.filter(i => i.__typename === 'Card').length || 0;
  const CARD_WIDTH = isContentEditable
    ? 'clamp(198px, 27vw, 323px)'
    : cardCount === 1
      ? '100%'
      : cardCount >= 7
        ? '22%'
        : cardCount === 2
          ? '45%'
          : cardCount === 4
            ? '45%'
            : '30%';

  const CARD_HEIGHT = isContentEditable
    ? ''
    : cardCount === 1 || cardCount === 2 || cardCount === 3
      ? '60vh'
      : '30vh';

  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: 'row',
      align: isContentEditable ? 'left' : 'center',
      wrap: true,
      padded: true,
      type: 'ul',
      // Nudge cards list upward slightly to reduce gap to title when sequence contains cards
      paddingTop: cardCount > 0 ? '4px' : undefined
    },
    items: []
  } as LayoutListDefinition;

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  // let i = 0;

  function showLogo() {
    // i++;
    // return i % 2 === 0;
    return true;
  }
  const questionCount =
    sequence.items?.filter(i => i.__typename === 'Question').length || 1;
  const root = translate(sequence, item => {
    if (item.__typename === 'Question') {
      cardsList.items.push({
        id: item.id,
        type: FLIP_CARD,
        values: {
          correct: item.items?.[0].correct || false,
          width: itemWidth[questionCount]?.width || '19.8%', // 10% smaller than 22%
          height: itemWidth[questionCount]?.height || '30vh',
          type: 'li'
        },
        items: [
          {
            id: `${item.id}.back`,
            type: FLIP_BACK,
            items: [
              {
                id: `${item.id}.backImg`,
                type: IMAGE,
                values: {
                  imageGenerationPlacement: 'card_image',
                  url: item.pictures?.[0].mediaUrl,
                  alt: item.pictures?.[0].name,
                  editable: false
                }
              } as ImageDefinition
            ]
          } as FlipBackDefinition,
          {
            id: `${item.id}.front`,
            type: FLIP_FRONT,
            items: [
              item.pictures && item.pictures[1]
                ? ({
                    id: `${item.id}.backImg`,
                    type: IMAGE,
                    values: {
                      imageGenerationPlacement: 'card_image',
                      url: item.pictures?.[1].mediaUrl,
                      alt: item.pictures?.[1].name,
                      editable: false
                    }
                  } as ImageDefinition)
                : ({
                    id: `${item.id}.front-list`,
                    type: LAYOUT_LIST,
                    values: {
                      padded: true
                    },
                    items: [
                      {
                        id: `${item.id}.front-heading`,
                        type: TEXT,
                        values: {
                          value: item.items?.[0].correct
                            ? t`Correct`
                            : t`Incorrect`,
                          variant: 'heading2'
                        }
                      } as TextDefinition,
                      {
                        id: `${item.id}.front-text`,
                        type: TEXT,
                        values: {
                          value: item.items?.[0].feedback,
                          maxHeight: isMobile ? '100px' : '72px',
                          canScroll: true
                        }
                      } as TextDefinition
                    ]
                  } as LayoutListDefinition)
            ]
          }
        ]
      } as FlipCardDefinition);
    } else if (item.__typename === 'Card') {
      const values = {
        width: CARD_WIDTH,
        height: CARD_HEIGHT,
        background: item.subtitle || 'var(--color-white)',
        type: 'li',
        cardTitle: item.title
      };

      cardsList.items.push({
        id: item.id,
        type: FLIP_CARD,
        values: values,
        items: [
          {
            id: `${item.id}.back`,
            type: FLIP_BACK,
            items: [
              sequence.personalization
                ? {
                    id: `${item.id}.backImg`,
                    type: PERSONALIZED_CARD,
                    values: {
                      showLogo: showLogo(),
                      vertical: true
                    }
                  }
                : !item.pictures ||
                    (Array.isArray(item.pictures) &&
                      item.pictures.length === 0) ||
                    (Array.isArray(item.pictures) &&
                      item.pictures.length > 0 &&
                      !item.pictures[0]?.mediaUrl)
                  ? ({
                      id: `${item.id}.front-list`,
                      type: LAYOUT_LIST,
                      values: {
                        padded: true,
                        align: 'center',
                        overflow: 'auto',
                        color: 'red'
                      },
                      items: [
                        {
                          id: `${item.id}.front-text`,
                          type: TEXT,
                          values: {
                            variant: 'heading2',
                            value: item.title
                          }
                        } as TextDefinition
                      ]
                    } as LayoutListDefinition)
                  : ({
                      id: `${item.id}.backImg`,
                      type: IMAGE,
                      values: {
                        imageGenerationPlacement: 'card_image',
                        url: item.pictures?.[0]?.mediaUrl,
                        alt: item.pictures?.[0]?.name,
                        editable: false
                      }
                    } as ImageDefinition)
            ]
          } as FlipBackDefinition,
          {
            id: `${item.id}.front`,
            type: FLIP_FRONT,
            items: [
              item.pictures && item.pictures[1]
                ? ({
                    id: `${item.id}.backImg`,
                    type: IMAGE,
                    values: {
                      imageGenerationPlacement: 'card_image',
                      url: item.pictures?.[1].mediaUrl,
                      alt: item.pictures?.[1].name,
                      editable: false
                    }
                  } as ImageDefinition)
                : ({
                    id: `${item.id}.front-list`,
                    type: LAYOUT_LIST,
                    values: {
                      padded: true,
                      // overflow: CARD_HEIGHT == '60vh' ? 'auto' : 'unset',
                      overflow: 'auto'
                    },
                    items: !isContentEditable
                      ? [
                          {
                            id: `${item.id}.front-text`,
                            type: TEXT,
                            values: {
                              value: item.body,
                              maxHeight: isMobile ? '160px' : '180px',
                              className: 'cards3-body'
                            }
                          } as TextDefinition
                        ]
                      : []
                  } as LayoutListDefinition)
            ]
          }
        ]
      } as FlipCardDefinition);
    } else if (item.__typename === 'Text') {
      mainList.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            orientation: 'column',
            align: 'center',
            paddingTop: '20px'
          },
          items: TextHelper(
            item as ItemOfType<'Text'>,
            {
              // fontSize: '18px'
            },
            isContentEditable ? false : true
          )
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  mainList.items.push(cardsList);

  // Show Add Card placeholder only in editor (CourseBuilder) mode.
  try {
    const { contentEditable } = useEditorStore.getState();
    if (contentEditable) {
      const existingCardCount = cardsList.items.filter(
        i => i.type === FLIP_CARD
      ).length;
      cardsList.items.push({
        id: `${sequence.id}.add-card-placeholder-${existingCardCount + 1}`,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        type: 'AddCardPlaceholder' as any,
        values: {
          width: CARD_WIDTH,
          height: '200px',
          text: t`Add a card`
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
    }
  } catch (e) {
    // silently ignore if store unavailable in this render context
  }

  if (mainList.items.length > 1) {
    // adding a dummy item for spacing... bit hackish but ok
    mainList.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.blank`
    } as LayoutListDefinition);
  }
  root.items.push(mainList);

  return root;
};
